import React, { useContext, useEffect, useReducer, useState } from "react";
import MvModal from './MvModal'
// @ts-ignore
import { LocalizationContext } from 'react-localize';
// Styles
import "./HopperPointsSummary.sass";
import "./modal.css";
import DataTable from "react-data-table-component";
import { HopperHomeReducer } from "../HopperHomeReducer";
import { InitState } from "../types";
import { formatNumber } from "../constant";

interface Props {
    header?: string;
    description: string;
    pointsSummary?: string;
    pointsHeading: string;
    openModal: boolean;
    closeiconnato: boolean;
    toggleModal: () => void;
    abort: () => void;
    confirm: () => void;
    reducerState: any;
    contractNumber: string;
    pointsAvailable:string;
    usageType:string;
    dates:string;
};

const HopperPointsSummary =(props: {
  header: any;
  pointsHeading(pointsHeading: any): string;
  pointsSummary(pointsSummary: any): string;
  eligibleUsage: any;
  openModal: boolean;
  closeiconnato: boolean | undefined;
  toggleModal: () => void; description: any; 
  contractNumber: string;
  pointsAvailable:string;
  usageType:string;
  dates:string;
}) => {
const { localize } = useContext(LocalizationContext);
const [reducerState, dispatch] = useReducer(HopperHomeReducer, InitState);
const [eligibleUsage, seteligibleUsage] = useState([]);
const [isTableLoading, setisTableLoading] = useState(false);

useEffect(() => {
  if(reducerState.ownerInfo === 'loading') {
    setisTableLoading(true);
  }
  else if(reducerState.ownerInfo !== 'loading' && Array.isArray(props.eligibleUsage)) {
    const eligibleUsage:any = props.eligibleUsage;
    const rulePassedeUsages = eligibleUsage.filter(({ ruleFailures }) => Array.isArray(ruleFailures) && ruleFailures.length <= 0)
    console.log('rulePassedeUsages', rulePassedeUsages);
    seteligibleUsage(rulePassedeUsages);
    setisTableLoading(false);
    console.log('eligibleUsage', props.eligibleUsage);
  } else if(reducerState.ownerInfo === 'error') {
    setisTableLoading(false);
    seteligibleUsage([]);
  }

}, [props.eligibleUsage]);

/** DIGMVO-170 */
const tableCustomStyles = {
  headRow: {
    style: {
      backgroundColor: '#E6F3F1',
    },
  },
  headCells: {
    style: {
      paddingLeft: '4px',
      paddingRight: '0px',
      color: '#000',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '28px',
      justifyContent: 'center !important',
    },
  },
  cells: {
    style: {
      paddingLeft: '4px',
      paddingRight: '0px',
      color: '#000',
      fontFamily: 'Montserrat',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '24px',
      backgroundColor: '#FFFFF',
      justifyContent: 'center !important'
    },
    stripedStyle: {
      backgroundColor: "#EFEFEF"
    }
  }
}
let rows:any = []; 
let columns: any = []; 
  
if(Array.isArray(props.eligibleUsage)) {
const eligibleUsageArr = eligibleUsage;
rows = eligibleUsageArr;
columns = [
  {
    name: props.contractNumber,
    selector: (row: { contractNumber: any; }) => row.contractNumber,
    sortable: true,
    reorder: true,
  },
  {
    name: props.pointsAvailable,
    selector: (row: { pointsAvailable: any; }) => row.pointsAvailable,
    cell: (row: any) => row && formatNumber(row.pointsAvailable),
    sortable: true,
    reorder: true,
    class: "summary-table-column"
  },
  {
    name: props.usageType,
    selector: (row: { usageTypeDesc: any; }) => row.usageTypeDesc,
    sortable: true,
    right: true,
    reorder: true,
    class: "summary-table-column"
  },
  {
    name: props.dates,
    selector: (row: { duration: any; }) => row.duration,
    sortable: true,
    right: true,
    reorder: true,
    class: "summary-table-column"
  },
  ];
}      
    
let modalBody;
if (props.description) {
    modalBody = (
        <div className='modal-body'>
            {props.header ? <p className="hopper-headline">{localize(props.header)}</p>: "" }
            <span className="hopper-headline-one" dangerouslySetInnerHTML={{ __html: localize(props.description) }}></span>
            <span className="hopper-headline-two" dangerouslySetInnerHTML={{ __html: localize(props.pointsHeading) }}></span>
            <span className="hopper-headline-three" dangerouslySetInnerHTML={{ __html: localize(props.pointsSummary) }}></span>
            
            <DataTable
                columns={columns}
                data={rows}
                defaultSortFieldId={1}
                className="hopper-summary-table"
                pagination
                striped
                customStyles={tableCustomStyles}
                progressPending={isTableLoading}
                noDataComponent="Balance is Zero, no details to display"
            />

        </div>
    );
}
return (
  <MvModal
      id="hopper-summary-modal"
      openModal={props.openModal}
      closeiconnato={props.closeiconnato}
      toggleModal={props.toggleModal}>
      <div className="hopper-summary-modal">
          {modalBody}
      </div>
  </MvModal>
);
};

HopperPointsSummary.contextType = LocalizationContext;
export {
    HopperPointsSummary,
};
